
export const mapAssetObj = (assetData) => {

	return {
		assetName: assetData.name,
		eTag: assetData.eTag,
		name: '', // THIS WILL REMOVE IN FUTURE RELEASE.
	};
};
